/*
 * @Author: your name
 * @Date: 2021-12-30 15:40:25
 * @LastEditTime: 2022-02-16 10:30:39
 * @LastEditors: Please set LastEditors
 * @Description: 标注
 * @FilePath: \smart-community\src\views\map\SatelliteMap\js\Marker.js
 */

import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import {
  Circle as CircleStyle,
  Fill,
  Icon,
  Stroke,
  Style,
  Text
} from "ol/style";

import util from "@util/js";
import { getDistance } from 'ol/sphere';
import LineString from 'ol/geom/LineString';
import Polyline from 'ol/format/Polyline';
import deviceIcon from "@/utils/deviceIcon";
import { getVectorContext } from 'ol/render';
import { Cluster, Vector as VectorSource } from "ol/source";
import { Vector as VectorLayer } from "ol/layer";
import handleCoordinates from "./handleCoordinates";
const { setPoint, reversePoint } = handleCoordinates();
const icon = require(`@/assets/images/map/icon/dingwei.png`);
class MoveLine {
  animating = false;
  distance = 0;
  angle = 0;
  i = 1;
  speed = 160;
  resolution = 1;
  moveMode = 1;
  lastTime;
  route = undefined;
  routesArray = [];
  routeFeatureArray = [];
  position = undefined;
  map = undefined;
  dis = undefined;
  source = undefined;

  constructor() {
      this.layer = undefined;
      this.polyLineLayer = undefined; //带箭头路径图层
      this.geoMarker = undefined;
      this.vectorLayer = undefined;
      this.pointMarker = [];
      this.lineArray = [];
    }
    //初始化
  initLine() {
      if (self.layer)
        self.map.removeLayer(self.layer);
      if (self.source)
        self.source.clear()
      this.pointMarker = []
      self.routesArray = []
      self.routeFeatureArray = []
      self.layer = undefined;
      self.source = undefined;
      self.distance = 0
      self.i = 1
    }
    // 创建图层
  createVector(myMap, showMovePoint) {
    const self = this;
    self.source = new VectorSource({
      features: [...[self.routeFeatureArray[0]], this.geoMarker],
    });
    const vectorLayer = new VectorLayer({
      source: self.source,
      style: function(feature) {
        return self.styles(feature)[feature.get('type')];
      },
    });
    myMap.on("click", e => {
      self.layer &&
        self.layer.getFeatures(e.pixel).then(clickedFeatures => {
          if (clickedFeatures.length) {
            // Get clustered Coordinates
            const features = clickedFeatures[0].values_;
            const vslus = clickedFeatures[0].values_;
            if (vslus.click) {
              vslus.click(features)
            }
          }
        });
    });
    this.vectorLayer = vectorLayer
    return vectorLayer;
  }

  /**
   * 边走边画路径
   *
   */
  addlineByMove(myMap, data) {
      const self = this;
      const lineArray = []
      console.log(data);
      data.forEach((item) => {
        lineArray.push(setPoint(item.location))
      })

      self.lineArray = lineArray
      for (let index = 0; index < lineArray.length - 1; index++) {
        let lineString = new LineString([lineArray[index], lineArray[index + 1]])
        let routerFeature = new Feature({
          type: 'route',
          id: index + 10,
          lineColor: data[index].info.color,
          lineWidth: data[index].info.width,
          geometry: lineString,
        });
        routerFeature.setId(index + 10)
        self.routesArray.push(lineString);
        self.routeFeatureArray.push(routerFeature);
      }
      this.route = self.routesArray[0]
      data.forEach((item, index) => {
        let feature = new Feature({
          type: 'icon',
          id: item.resultId,
          geometry: new Point(setPoint(item.location)),
          ...item
        })
        feature.setId(item.resultId);
        this.pointMarker.push(feature)
      })
      const position = this.pointMarker[0].getGeometry().clone();
      this.position = position
      this.geoMarker = new Feature({
        type: 'geoMarker',
        geometry: position,
        ...data[0]
      });
      if (!self.layer) {
        self.layer = self.createVector(myMap, data[0].showMovePoint);
        self.map = myMap
        myMap.addLayer(self.layer);
      }
      setTimeout(() => {
        console.log(self.source);
        self.startAnimation()
      }, 3000);
    }
    // 清空标注
  clearLine() {
      const self = this;
      if (self.layer == undefined) return
      return new Promise(resolve => {
        setTimeout(() => {
          self.map.removeLayer(self.layer);
          self.map.removeLayer(self.polyLineLayer);
          self.source && self.source.clear()
          this.pointMarker = []
          self.routesArray = []
          self.routeFeatureArray = []
          self.layer = undefined;
          self.polyLineLayer = undefined;
          self.source = undefined;
          self.distance = 0
          self.i = 1
          resolve();
        }, 10);
      });

    }
    //动画函数
    // moveMode 运动模式，1转向，完成一圈后停止；2、不转向完成一圈后继续
  moveFeature = (event) => {
      const self = this;
      const speed = Number(self.speed + 50);
      const time = event.frameState.time;
      const elapsedTime = time - this.lastTime;
      self.distance = (self.distance + (speed * elapsedTime) / 1e6) % 2;
      self.lastTime = time;
      let currentCoordinate
      if (self.moveMode == 1) {
        currentCoordinate = self.route && self.route.getCoordinateAt(
          self.distance > 1 ? 1 : self.distance
        );
      } else {
        currentCoordinate = self.route && self.route.getCoordinateAt(
          self.distance > 1 ? 2 - self.distance : self.distance
        );
      }
      self.position.setCoordinates(currentCoordinate);
      const vectorContext = getVectorContext(event);

      vectorContext.setStyle(self.styles(this.geoMarker).geoMarker);
      vectorContext.drawGeometry(self.position);
      if (self.distance > 1) {
        if (self.i == self.lineArray.length - 1) {
          this.stopAnimation()
          return
        }
        if (self.i) self.source.addFeature(self.routeFeatureArray[self.i])
        this.route = self.routesArray[self.i]
        self.distance = 0
          ++self.i
      }
      self.map.render();
    }
    //开始移动
  startAnimation = () => {
      const self = this;
      this.animating = true;
      this.lastTime = Date.now();
      // self.getAngle(self.i - 1)
      this.vectorLayer.on('postrender', self.moveFeature);
      setTimeout(() => {
        self.geoMarker.setGeometry(null);
      }, 100)

    }
    //结束
  stopAnimation = () => {
    const self = this;
    this.animating = false;
    this.geoMarker.setGeometry(self.position);
    this.vectorLayer.un('postrender', self.moveFeature);
  }
  getAngle = (i) => {
      const self = this;
      if (i > self.lineArray.length - 2) return
      let end = self.lineArray[i]
      let start = self.lineArray[i + 1]
      let dx = end[0] - start[0];
      let dy = end[1] - start[1];
      let rotation = Math.atan2(dy, dx)
      let angleIn = rotation * (180 / Math.PI);
      if (angleIn < 90 && angleIn > 0) {
        self.angle = -((angleIn / 180) * Math.PI) + 1.5 * Math.PI
      } else if (angleIn > 90) {
        self.angle = -((angleIn / 180) * Math.PI) - 0.5 * Math.PI
      } else if (angleIn > 90 && angleIn < 180) {
        // self.angle = 0.5 * Math.PI
      } else if (angleIn < 0 && angleIn > -90) {
        self.angle = ((-angleIn / 180) * Math.PI) + 1.5 * Math.PI
      } else if (angleIn < -90) {
        self.angle = -(((180 + angleIn) / 180) * Math.PI) + 0.5 * Math.PI
      }

    }
    /**
     * 区域标注的样式
     */
  styles(feature) {
    const self = this;
    const form = feature.values_;
    let icon = "";
    if (!form.poiType) {
      form.poiType = "default";
    }
    if (form.poiType in deviceIcon && deviceIcon[form.poiType].iconImg) {
      icon = deviceIcon[form.poiType].iconImg;
    } else if (form.poiType === "area") {
      icon = require(`@/assets/images/map/icon/timg.png`);
    }
    return {
      'route': new Style({
        stroke: new Stroke({
          width: form.lineWidth ? form.lineWidth : '5',
          color: '#67c23a',
        }),
      }),
      'icon': form.showType === 1 ?
        new Style({
          image: new Icon({
            scale: 0.6,
            anchor: [0.5, 1],
            src: icon,
          }),
        }) : new Style({
          image: new Icon({
            scale: 0.7,
            anchor: [0.5, 1],
            src: icon,
            offsetY: -25,
          }),
          text: new Text({
            textAlign: "center", // 位置
            textBaseline: "middle", // 基准线
            offsetY: -8,
            text: feature.values_.num,
            font: "16px Calibri",
            fill: new Fill({
              color: "black"
            })
          })
        }),
      'geoMarker': new Style({
        image: new Icon({
          scale: 0.8,
          anchor: [0.5, 0.5],
          anchorOrigin: "bottom-center", // 锚点源
          src: icon,
          rotateWithView: true,
          rotation: self.angle
        }),
        text: new Text({
          textAlign: "center", // 位置
          textBaseline: "middle", // 基准线
          offsetY: -30,
          text: form.name,
          font: "14px Calibri",
          fill: new Fill({
            color: "red"
          })
        })
      }),

    };

  }



}
export default MoveLine;